// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dro5","colMin":"styles_colMin__huMfp"};